import React from 'react';

// components
import {CardBorder} from '../../../../shared/components';

// styles
import {
  CardQuickLinkBottom,
  CardQuickLinkWrapper,
} from './CardQuickLink-styles';
import {TextColors, TextDefault} from '../../../../shared/styles';

// types
export type QuickLink = {
  title_key: string;
  description_key: string;
  href: string;
  Icon: React.ComponentType;
};

type Props = {
  quickLink: QuickLink;
  displayDescription: boolean;
};

const CardQuickLink = ({quickLink, displayDescription}: Props) => {
  const Icon = quickLink.Icon;

  return (
    <CardBorder variant="primary">
      <CardQuickLinkWrapper to={quickLink.href}>
        <Icon />
        <CardQuickLinkBottom>
          <TextDefault bold="bold">{quickLink.title_key}</TextDefault>
          {displayDescription && (
            <TextDefault color={TextColors.secondary}>
              {quickLink.description_key}
            </TextDefault>
          )}
        </CardQuickLinkBottom>
      </CardQuickLinkWrapper>
    </CardBorder>
  );
};

export default CardQuickLink;
